export const FLAG_GETTING_EXTRA_FUEL_CONSUMPTIONS =
  'FLAG_GETTING_EXTRA_FUEL_CONSUMPTIONS';
export const GET_EXTRA_FUEL_CONSUMPTIONS = 'GET_EXTRA_FUEL_CONSUMPTIONS';
export const CLEAR_EXTRA_FUEL_CONSUMPTIONS = 'CLEAR_EXTRA_FUEL_CONSUMPTIONS';
export const FLAG_EXTRA_FUEL_CONSUMPTION_ACTIVITY =
  'FLAG_EXTRA_FUEL_CONSUMPTION_ACTIVITY';
export const GET_EXTRA_FUEL_CONSUMPTION = 'GET_EXTRA_FUEL_CONSUMPTION';
export const CLEAR_EXTRA_FUEL_CONSUMPTION = 'CLEAR_EXTRA_FUEL_CONSUMPTION';
